import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Notiflix from "notiflix";

export const MySwal = withReactContent(Swal);

export function Popup(jsx, options, func, funcCancel, preConfirm) {
  MySwal.fire({
    width: options == undefined ? "50%" : options.width,
    html: jsx,
    showConfirmButton: options == undefined ? false : options.showConfirmButton,
    showCancelButton: options == undefined ? false : options.showCancelButton,
    background: options == undefined ? "" : options.background,
    showCloseButton: true,
    preConfirm: async () => {
      if (preConfirm) {
        let status = await preConfirm();
        if (status) {
          return status;
        } else {
          MySwal.showValidationMessage(`Lütfen Alanları Doldurunuz`);
        }
      }
    },
    customClass: {},
  }).then((result) => {
    if (result.isConfirmed) {
      if (func) {
        func();
      }
    } else {
      if (funcCancel) {
        funcCancel();
      }
    }
  });
}

const load = Notiflix.Loading;

export const loading = () => {
  load.pulse({
    backgroundColor: "rgba(0,0,0,0.35)",
  });
};
export const removeLoading = async () => {
  await load.remove();
};
